/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ApiResponseOfPermissionsGroupBodyArray } from '../model';
/**
 * PermissionsGroupsApi - axios parameter creator
 * @export
 */
export const PermissionsGroupsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionsGroups: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/permissionsGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PermissionsGroupsApi - functional programming interface
 * @export
 */
export const PermissionsGroupsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PermissionsGroupsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPermissionsGroups(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfPermissionsGroupBodyArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPermissionsGroups(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PermissionsGroupsApi - factory interface
 * @export
 */
export const PermissionsGroupsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PermissionsGroupsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionsGroups(options?: any): AxiosPromise<ApiResponseOfPermissionsGroupBodyArray> {
            return localVarFp.getPermissionsGroups(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PermissionsGroupsApi - interface
 * @export
 * @interface PermissionsGroupsApi
 */
export interface PermissionsGroupsApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsGroupsApiInterface
     */
    getPermissionsGroups(options?: any): AxiosPromise<ApiResponseOfPermissionsGroupBodyArray>;

}

/**
 * PermissionsGroupsApi - object-oriented interface
 * @export
 * @class PermissionsGroupsApi
 * @extends {BaseAPI}
 */
export class PermissionsGroupsApi extends BaseAPI implements PermissionsGroupsApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsGroupsApi
     */
    public getPermissionsGroups(options?: any) {
        return PermissionsGroupsApiFp(this.configuration).getPermissionsGroups(options).then((request) => request(this.axios, this.basePath));
    }
}
